/**
 * Feature context — provided by the shell app, consumed by feature pages.
 * Features never import api/auth/toast directly; they receive them via context.
 */
import { createContext, useContext } from "react";
export const FeatureCtx = createContext(null);
/** Hook for feature pages to access shell-provided context. */
export function useFeature() {
    const ctx = useContext(FeatureCtx);
    if (!ctx)
        throw new Error("useFeature must be used within a FeatureProvider (shell)");
    return ctx;
}
//# sourceMappingURL=context.js.map